import React from "react";
import { useNavigate, useLocation } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavLink = (e, sectionId, category = null) => {
    e.preventDefault();

    const url = category ? `/?category=${encodeURIComponent(category)}` : "/";

    if (location.pathname !== "/") {
      navigate(url, { replace: false });

      setTimeout(() => {
        const section = document.querySelector(sectionId);
        if (section) {
          section.scrollIntoView({ behavior: "smooth" });
        }
      }, 300);
    } else {
      if (category) {
        // Just update query param without full reload
        navigate(`?category=${encodeURIComponent(category)}`, {
          replace: true,
        });
      }

      const section = document.querySelector(sectionId);
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
    }
  };
  return (
    <footer id="footer" className="footer dark-background">
      <div className="container footer-top">
        <div className="row gy-4">
          <div className="col-lg-4 col-md-6 footer-about">
            <a href="index.html" className="logo d-flex align-items-center">
              <span className="sitename">
                <img src="/assets/img/Logo-Innovex.png" alt="Logo" />
              </span>
            </a>
            <div className="footer-contact pt-3">
              <h6>Office & Factory</h6>
              <p>
                Plot No.38, Mahalaxmi Estate, Iyava, Sanad, Ahmedabad-382170,
                Gujarat ( IND )
              </p>
              <p className="mt-3">
                <strong>Phone:</strong> <span>+91 89896 16200</span>
              </p>
              <p>
                <strong>Email:</strong> <span>innovexcroptech@gmail.com</span>
              </p>
            </div>
            <div className="social-links d-flex mt-4">
              <a href="https://www.facebook.com/people/innovex-crop-technologies/61570032313455/">
                <i className="bi bi-facebook" />
              </a>
              <a href="https://www.instagram.com/innovex_crop/?utm_source=qr&igsh=dTk0aGQ4dDc1ZmRv#">
                <i className="bi bi-instagram" />
              </a>
            </div>
          </div>
          <div className="col-lg-2 col-md-3 footer-links">
            <h4>Useful Links</h4>
            <ul>
              <li>
                <i className="bi bi-chevron-right" /> <a href="/">Home</a>
              </li>
              <li>
                <i className="bi bi-chevron-right" />{" "}
                <a href="/#about" onClick={(e) => handleNavLink(e, "#about")}>
                  About us
                </a>
              </li>
              <li>
                <i className="bi bi-chevron-right" />{" "}
                <a href="/#team" onClick={(e) => handleNavLink(e, "#team")}>
                  Team
                </a>
              </li>
              <li>
                <i className="bi bi-chevron-right" />{" "}
                <a
                  href="/#contact"
                  onClick={(e) => handleNavLink(e, "#contact")}
                >
                  Contact us
                </a>
              </li>
              <li>
                <i className="bi bi-chevron-right" />{" "}
                <a href="#">Terms of service</a>
              </li>
              <li>
                <i className="bi bi-chevron-right" />{" "}
                <a href="#">Privacy policy</a>
              </li>
            </ul>
          </div>
          <div className="col-lg-2 col-md-3 footer-links">
            <h4>Our Products</h4>
            <ul>
              <li>
                <i className="bi bi-chevron-right" />{" "}
                <a
                  href="/#product"
                  onClick={(e) => handleNavLink(e, "#product", "fungicide")}
                >
                  Fungicide
                </a>
              </li>
              <li>
                <i className="bi bi-chevron-right" />{" "}
                <a
                  href="/#product"
                  onClick={(e) => handleNavLink(e, "#product", "insecticide")}
                >
                  Insecticide
                </a>
              </li>
              <li>
                <i className="bi bi-chevron-right" />{" "}
                <a
                  href="/#product"
                  onClick={(e) => handleNavLink(e, "#product", "pgr")}
                >
                  Plant Grow Regulator
                </a>
              </li>
              <li>
                <i className="bi bi-chevron-right" />{" "}
                <a
                  href="/#product"
                  onClick={(e) => handleNavLink(e, "#product", "herbicide")}
                >
                  Herbicide
                </a>
              </li>
              <li>
                <i className="bi bi-chevron-right" />{" "}
                <a
                  href="/#product"
                  onClick={(e) => handleNavLink(e, "#product", "fertilizer")}
                >
                  Fertilizer
                </a>
              </li>
            </ul>
          </div>
          <div className="col-lg-4 col-md-12 footer-newsletter">
            <h4>Our Newsletter</h4>
            <p>
              Subscribe to our newsletter and receive the latest news about our
              products !
            </p>
            <form
              action="forms/newsletter.php"
              method="post"
              className="php-email-form"
            >
              <div className="newsletter-form">
                <input type="email" name="email" />
                <input type="submit" defaultValue="Subscribe" />
              </div>
              <div className="loading">Loading</div>
              <div className="error-message" />
              <div className="sent-message">
                Your subscription request has been sent. Thank you!
              </div>
            </form>
          </div>
        </div>
      </div>
      <div className="container copyright text-center mt-4">
        <p>
          © <span>Copyright</span>{" "}
          <strong className="px-1 sitename">
            Innovex - Agro Chemicals Manufacturers Pvt. Ltd | Fungicide
            ,Insecticide ,PGR ,Herbicide , Fertilizer
          </strong>{" "}
          <span>All Rights Reserved</span>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
